import fascias from "./fascias";

export const caddy = {
    namespaced: true,
    modules: {
        fascias
    }
};



// WEBPACK FOOTER //
// ./src/store/plano/caddy/index.js